import clsx from "clsx";
import PropTypes from "prop-types";
import { Form as SemanticForm } from "semantic-ui-react";
import { Radio } from "../../Radio";
import "./form-radio.scss";

/**
 * DEPRECATED - Use design system components instead
 * */
export const LegacyFormRadio = ({
  className = "",
  disabled = false,
  label = "",
  id,
  ...props
}) => {
  return (
    <SemanticForm.Field className={clsx("ha-form-radio", className)}>
      <Radio {...props} disabled={disabled} id={id} />
      {!!label && (
        <label
          className={clsx("ha-form-radio-label", {
            "ha-form-radio-label-disabled": disabled,
          })}
          htmlFor={id}
        >
          {label}
        </label>
      )}
    </SemanticForm.Field>
  );
};

LegacyFormRadio.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
};
